import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import Icon from "../Icon/Icon";
import s from "./Modal.module.scss";

/**
 * Guscio unico dei modali: overlay, pannello, intestazione, corpo che scorre
 * e piede con le azioni. Esc e clic fuori chiudono (se `dismissable`).
 */
export default function Modal({
  title,
  subtitle,
  onClose,
  children,
  footer,
  size = "md",
  dismissable = true,
  className = "",
  bodyClassName = "",
}) {
  const panelRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && dismissable) onClose?.();
    };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    // Fuoco nel modale: tastiera e lettori di schermo partono da qui.
    const t = setTimeout(() => {
      const el = panelRef.current?.querySelector("input:not([type=hidden]), textarea, select, button");
      if (el && !panelRef.current.contains(document.activeElement)) el.focus({ preventScroll: true });
    }, 30);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
      clearTimeout(t);
    };
  }, [onClose, dismissable]);

  return createPortal(
    <div className={s.overlay} onMouseDown={(e) => dismissable && e.target === e.currentTarget && onClose?.()}>
      <div ref={panelRef} className={`${s.panel} ${s[size] || ""} ${className}`} role="dialog" aria-modal="true" aria-label={typeof title === "string" ? title : undefined}>
        {(title || onClose) && (
          <div className={s.header}>
            <div className={s.headerText}>
              {title && <h2 className={s.title}>{title}</h2>}
              {subtitle && <p className={s.subtitle}>{subtitle}</p>}
            </div>
            {onClose && (
              <button type="button" className={s.close} onClick={onClose} aria-label="Chiudi">
                <Icon name="close" size={20} />
              </button>
            )}
          </div>
        )}
        <div className={`${s.body} ${bodyClassName}`}>{children}</div>
        {footer && <div className={s.footer}>{footer}</div>}
      </div>
    </div>,
    document.body,
  );
}
